export enum CheckBoxLabelPosition {
  LEFT,
  RIGHT,
}
